module.exports = __webpack_public_path__ + "static/media/round_bg.26f93aaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/round_bg.svg
// module id = 126
// module chunks = 0